import { render, staticRenderFns } from "./sms_marketing.vue?vue&type=template&id=12707263&"
import script from "./sms_marketing.vue?vue&type=script&lang=js&"
export * from "./sms_marketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports